import { connect } from 'react-redux';
import { graphql } from '@apollo/react-hoc';
import { toGlobalId } from 'graphql-relay';
import { compose } from 'react-recompose';

import { SimpleLoadingComponent } from '../../utils/apollo';
import CollegeEventsViewEvents from './view-events';
import fetchCollegeEventsQuery from './graphql/fetchCollegeEventsQuery';
import fetchAmEventsAttendeeExportAvailable from './graphql/fetchAmEventsAttendeeExportAvailable';
import changeCollegeEventStatusMutation from './graphql/changeCollegeEventStatusMutation';
import formatDate from '../../utils/format-date';
import { withEnabledFeatures } from '../../utils/features';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';

const changeCollegeEventStatus = graphql(changeCollegeEventStatusMutation, { name: 'changeCollegeEventStatus' });
const fetchAmEventsAttendeeExpAvailable = graphql(fetchAmEventsAttendeeExportAvailable, { name: 'fetchAmEventsAttendeeExportAvailable' });
const graphqlData = graphql(fetchCollegeEventsQuery, {
  options: (props) => {
    const scid = props.current.viewer.idToken['custom:institution'];
    const globalSCID = toGlobalId('HEAccount', scid);
    return {
      fetchPolicy: 'cache-and-network',
      variables: {
        scid: globalSCID,
        fromDate: formatDate(new Date(), true),
      },
    };
  },
});

const mapStateToProps = (state) => ({
  current: state.current,
});

const loadingComponent = SimpleLoadingComponent(
  compose(
    withEnabledFeatures,
    withHEAccountSubscriptions,
    graphqlData,
  ),
  changeCollegeEventStatus,
  fetchAmEventsAttendeeExpAvailable,
)(CollegeEventsViewEvents);
const connectedComponent = connect(mapStateToProps, {})(loadingComponent);
export default connectedComponent;
